<ul class="nav nav-pills mb-2" role="tablist">
  @for (tab of tabs; track tab.value) {
    @if (tab.visible !== false) {
      <li class="nav-item" role="presentation">
        <button class="nav-link" [ngClass]="{ active: selectedTab === tab.value }" (click)="selectTab(tab.value)">
          <i *ngIf="tab.icon" [class]="tab.icon"></i>
          <span class="ms-2">{{ tab.label }}</span>
          <span
            *ngIf="tab.badge !== undefined"
            class="badge rounded-pill ms-2"
            [ngClass]="{ 'bg-primary': selectedTab === tab.value, 'bg-secondary': selectedTab !== tab.value }">
            {{ tab.badge }}
          </span>
        </button>
      </li>
    }
  }
</ul>
